import { render, staticRenderFns } from "./TaxExplain.vue?vue&type=template&id=7687ba56&scoped=true&"
import script from "./TaxExplain.vue?vue&type=script&lang=js&"
export * from "./TaxExplain.vue?vue&type=script&lang=js&"
import style0 from "./TaxExplain.vue?vue&type=style&index=0&id=7687ba56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7687ba56",
  null
  
)

export default component.exports